<template>
  <div>
    <b-modal ref="view-cart-modal" size="lg" hide-footer centered>
      {{getCurrentLanguage()}}
      <b-table-simple responsive>
        <b-thead class="text-center">
          <b-tr>
            <b-th sticky-column>id</b-th>
            <b-th>{{ $t('image') }}</b-th>
            <b-th>{{ $t('name') }}</b-th>
            <b-th>{{ $t('price') }}</b-th>
            <b-th>{{ $t('quantity') }}</b-th>
            <b-th>{{ $t('remove') }}</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr class="text-center" v-for="product in this.$products" v-if="cart && cart[product.pk]" :key="product.pk">
            <b-th stacked sticky-column>{{ product.pk }}</b-th>
            <b-td stacked><img width="100" alt="product image" :src="`${$request}media/${product.fields.image}`"></b-td>
            <b-td stacked>{{ product.fields['name_' + getCurrentLanguage()] }}</b-td>
            <b-td stacked>
              <span class="mr-2" :class="+product.fields.discounted_price? 'text-del text-danger' : ''">{{Math.round(product.fields.price)}} {{ $t('amd') }}</span>
              <span v-if="+product.fields.discounted_price"> {{Math.round(product.fields.discounted_price)}} {{ $t('amd') }}</span>
            </b-td>
            <b-td stacked>
              <b-form-spinbutton width="155" @change="handleQtyChange" v-model="cart[product.pk].qty" min="1" max="1000"></b-form-spinbutton>
            </b-td>
            <b-td stacked>
              <button @click="btnAction($event.currentTarget)" :data-pk="product.pk" :next-step="'remove'" :ref="'check_button_'+[product.pk]" class="btn btn btn-outline-danger" ><img alt="remove" :src="xSVG"></button>
            </b-td>
          </b-tr>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-td colspan="7" variant="warning" class="text-right">
              <b>{{`${this.total} ${$t('amd')}`}}</b>
            </b-td>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
      <div class="container-fluid">
        <b-card bg-variant="light">
          <p class="h5 text-center"><b>{{ $t('order') }}</b></p>
          <b-form-group class="mb-0">
            <p class="mb-1">{{ $t('city') }} *</p>
            <b-form-select v-model="order.city" :options="available_cities" :state="order.validation.city" @change="countTotal()" />
            <p class="mt-3 mb-1">{{ $t('address') }} *</p>
            <b-form-input type="text" min="5" v-model="order.address" :state="order.validation.address" />
            <p class="mt-3 mb-1">{{ $t('phone_number') }} *</p>
            <b-form-input type="number" min="9" v-model="order.number" :state="order.validation.number" />
            <p class="mt-3 mb-1">{{ $t('additional_description') }}</p>
            <b-form-textarea type="text" v-model="order.description" />
            <p class="mt-3 mb-1">{{ $t('deliver_as_soon_as_possible') }}</p>
            <b-form-checkbox v-model="order.as_soon_as_possible" />
            <div v-if="!order.as_soon_as_possible" class="container-fluid pb-3 border">
              <div class="row">
                <div class="col">
                  <p class="mt-3 mb-1">{{ $t('date') }} *</p>
                  <b-form-datepicker max-width="100" type="date" v-model="order.date" :state="order.validation.date" />
                </div>
                <div class="col">
                  <p class="mt-3 mb-1">{{ $t('time') }} *</p>
                  <b-form-timepicker
                    type="time"
                    v-model="order.time"
                    hide-header
                    no-close-button
                    minutes-step="5"
                    :hour12="false"
                    :state="order.validation.time" />
                </div>
              </div>
            </div>
            <div v-if="isValid !== null" class="container-fluid m-0 p-0 mt-2">
              <p class="text-danger h6" v-if="!isValid">
                <b-icon icon="exclamation-circle" /> {{ $t('correct_fill_all_required_fields') }}
              </p>
              <p class="text-success h2" v-if="isValid">
                <b-icon icon="check"></b-icon>
              </p>
            </div>
            <div class="mt-3 order-section">
              <span>{{ `${$t('total')} - ${totalWithDeliveryPrice} ${$t('amd')}` }}</span>
              <b-form-group>
                <b-form-radio-group
                  id="pay-checkbox"
                  v-model="order.payment"
                >
                  <p class="p-1 h5 text-right">{{$t('payment_method')}}</p>
                  <b-form-radio class="m-0 text-center" value="cash">
                    <div class="p-1 radio-wrapper">
                      <img height="40" alt="logo" src="static/cash.png" >
                      <p class="m-0 mt-2 text-center">{{ $t('cash') }}</p>
                    </div>
                  </b-form-radio>
                  <b-form-radio class="m-0 text-center" value="idram">
                    <div class="p-1 radio-wrapper">
                      <img height="40" alt="Idram" src="static/idram.png">
                      <p class="m-0 mt-2 text-center">Idram</p>
                    </div>
                  </b-form-radio>
<!--                  <b-form-radio class="m-0 text-center" value="card">-->
<!--                    <div class="p-1 radio-wrapper">-->
<!--                      <img height="40" alt="Card" src="static/card.png">-->
<!--                      <p class="m-0 mt-2 text-center">Master/Visa/Arca</p>-->
<!--                    </div>-->
<!--                  </b-form-radio>-->
                </b-form-radio-group>
              </b-form-group>
              <b-button @click="placeOrder" variant="warning" class="text-light" disabled><b>{{ $t('order') }}</b></b-button>
            </div>
          </b-form-group>
          <div class="container-fluid m-0 p-0 mt-5 text-secondary">
            <p class="h6"><b>{{ $t('order_conditions') }}</b></p>
            <p class="h6"><i>{{ $configs.fields['order_conditions_'+getCurrentLanguage()] }}</i></p>
          </div>
        </b-card>
      </div>
    </b-modal>
    <form v-show="false" ref="idram_form" action="https://banking.idram.am/Payment/GetPayment" method="POST">
      <input type="hidden" name="EDP_LANGUAGE" value="EN">
      <input type="hidden" name="EDP_REC_ACCOUNT" value="110001389">
      <input type="hidden" name="EDP_DESCRIPTION" value="https://panino.am/shop">
      <input type="hidden" name="EDP_AMOUNT" :value="totalWithDeliveryPrice">
      <input type="hidden" name="EDP_BILL_NO" :value="order_id">
      <input  type="submit" value="submit" />
    </form>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueI18n from 'vue-i18n';

export default {
  name: "cartComponent",
  props: [
    'parentRefs'
  ],
  data(){
    return {
      fields: ['id'],
      cart: this.$cookies.get('cart'),
      total: 0,
      totalWithDeliveryPrice: 0,
      order: {
        as_soon_as_possible: true,
        city: this.$available_cities[0].pk,
        payment: 'cash',
        validation: {
          city: null,
          address: null,
          number: null,
          date: null,
          time: null
        }
      },
      order_id: null, //after order submit
      isValid: null,
      available_cities: [],
      xSVG: require('@/assets/x.svg'),
    }
  },
  watch: {
    '$i18n.locale': function() {
      this.availableCitiesList()
    }
  },
  mounted() {
    this.availableCitiesList()
    this.countTotal()
  },
  methods: {
    showModal() {
      this.cart = this.$cookies.get('cart')
      this.countTotal()
      this.$refs['view-cart-modal'].show()
    },
    hideModal() {
      this.$refs['view-cart-modal'].hide()
    },
    handleQtyChange(){
      this.countTotal()
      this.updateCart()
    },
    availableCitiesList(){
      this.available_cities = []
      for(let city in this.$available_cities){
        this.available_cities.push(
          {
            value: this.$available_cities[city].pk,
            text: `${this.$available_cities[city].fields['city_'+this.getCurrentLanguage()]} (${Math.round(this.$available_cities[city].fields.delivery_price)} ${this.$t('amd')})`
          }
        )
      }
    },
    fiendCityById(id){
      for(let city in this.$available_cities){
        if(this.$available_cities[city].pk === id){
          return this.$available_cities[city]
        }
      }
    },
    countTotal(){
      this.total = 0
      if(this.cart){
        Object.keys(this.cart).forEach(cartItemKey => {
          Object.keys(this.$products).forEach(productKey => {
            if(+cartItemKey === this.$products[productKey].pk){
              if(+this.$products[productKey].fields.discounted_price){
                this.total += +this.$products[productKey].fields.discounted_price * this.cart[cartItemKey].qty
              } else {
                this.total += +this.$products[productKey].fields.price * this.cart[cartItemKey].qty
              }
            }
          })
        })
      }
      this.countTotalWithDeliveryPrice()
    },
    countTotalWithDeliveryPrice(){
      const total = this.total
      const city = this.fiendCityById(this.order.city)
      this.totalWithDeliveryPrice = total + +city.fields.delivery_price
    },
    getCurrentLanguage(){
      return this.$i18n.locale
    },
    updateCart(){
      this.$cookies.set('cart', this.cart)
      this.$emit('updateCart')
    },
    btnAction(btn){
      const id = btn.getAttribute('data-pk')
      if(this.$refs['check_button_' + id][0].getAttribute('next-step') === 'remove'){
        this.cart[id] = {}
        delete this.cart[id]
        this.$cookies.set('cart', this.cart)
        this.countTotal()
      }
      this.updateCart()
    },
    orderValidation(){
      this.order.validation.city = !!this.order.city
      this.order.validation.address = !!(this.order.address && this.order.address.length >= 5)
      this.order.validation.number = !!(this.order.number && this.order.number.length >= 9)
      if(!this.order.as_soon_as_possible){
        this.order.validation.date = !!this.order.date
        this.order.validation.time = !!this.order.time
      }
      this.isValid = Object.values(this.order.validation).indexOf(false) < 0
      return this.isValid
    },
    placeOrder(){
      if(false){//this.orderValidation()){
        this.$loader.show()
        axios.post(
          Vue.prototype.$request + 'order',
          JSON.stringify({order: this.order, cart: this.cart}),
          // {timeout: 2000} //ms
        ).then(response => {
          if(response.data.success){
            this.order_id = response.data.order_id
            if(this.order.payment === 'idram'){
              Vue.nextTick(() => {
                this.cart = {}
                this.updateCart()
                this.$refs.idram_form.submit()
              })
            } else if(this.order.payment === 'card'){
              alert("Not ready yet...")
            } else {
              this.orderStatus(true)
          }} else{
            this.orderStatus(false)
          }
        }).catch((error) => {
          this.orderStatus(false)
        })
      }
    },
    orderStatus(success){
      if(success){
        this.cart = {}
        this.updateCart()
        this.hideModal()
        this.$nextTick(() => {
          this.$emit('orderMessage', true)
        })
      } else {
        this.hideModal()
        this.$nextTick(() => {
          this.$emit('orderMessage', false)
        })
      }
      this.$loader.hide()
    },
  }
}
</script>

<style scoped>
.text-del{
  text-decoration: line-through;
}
.order-section span{
  line-height: 38px;
  text-align: center;
}
.order-section button{
  float: right;
}
#pay-checkbox{
  float: right;
}
[type=radio]:checked + label .radio-wrapper {
  border: 2px lightgray solid;
  border-radius: 10px;
  opacity: 1;
}
.radio-wrapper{
  border: 2px lightgray dashed;
  border-radius: 10px;
  opacity: 0.8;
  cursor: pointer;
}
</style>
<style>
#pay-checkbox .custom-radio .custom-control-label::before {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cartComponent.vue